export const apiKeys = {
    prod: "xE9R2jhxgi963bGcUll2K2iPYzK5JXLL4UMAeYgg",
    preProd: "IwOAvQ34Va8kev2DcVKqk7fcsWk19ucH8p7Z0Ind"
  };